import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne"
import { Header } from "./Header"
import { Footer } from "./Footer"
import { Seo } from "./Seo"

export const Layout = ({ isHomePage, children }) => {
  const {
    wp: {
      generalSettings: { title },
    },
  } = useStaticQuery(graphql`
    query LayoutQuery {
      wp {
        generalSettings {
          title
          description
        }
      }
    }
  `)
  return (
    <>
      <Seo title="Creazione Siti web, Web App e Mobile App" />

      <main className="main-wrapper">
        <Header />
        <BreadCrumbOne title={title} page="Pixiel Blog" />

        <div className="container">{children}</div>
        <Footer />
      </main>
    </>
  )
}

export default Layout
